import { useMemo } from 'react';

import { Card, Group, Stack, ThemeIcon } from '@mantine/core';
import { DateTime } from 'luxon';
import { IconCalendar, IconTicket } from 'ui-icons';

import { Text, Title } from '../../../../Typography';
import classes from './EventWalletCard.module.css';

interface EventWalletCardProps {
  eventName: string;
  onClick?: () => void;
  ticketCount?: number;
  imageSrc?: string;
  startingAt?: string;
  endingAt?: string;
}

const EventWalletCard = ({
  eventName,
  onClick,
  ticketCount,
  imageSrc,
  startingAt,
  endingAt,
}: EventWalletCardProps) => {
  const datetime = useMemo(() => {
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    const isOneDayEvent = DateTime.fromISO(startingAt).hasSame(
      DateTime.fromISO(endingAt ?? ''),
      'day'
    );

    if (isOneDayEvent) {
      // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
      const startDate = DateTime.fromISO(startingAt).toFormat('LLL d');
      // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
      const startTime = DateTime.fromISO(startingAt)
        .toLocaleString(DateTime.TIME_SIMPLE)
        .replace(' AM', 'am')
        .replace(' PM', 'pm');
      // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
      const timezone = DateTime.fromISO(startingAt).toFormat('ZZZZ');

      return `${startDate}, ${startTime} ${timezone}`;
    }
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    return `${DateTime.fromISO(startingAt).toFormat('LLL d')} - ${DateTime.fromISO(
      // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
      endingAt
    ).toFormat('LLL d')}`;
  }, [startingAt, endingAt]);

  return (
    <Card
      component="button"
      className={classes.EventWalletCard}
      style={{
        '--event-wallet-card-image': `url(${imageSrc})`,
      }}
      onClick={onClick}
    >
      <Stack gap="sm" w="100%">
        <Title order={4} c="white" ta="left">
          {eventName}
        </Title>
        <Group justify="space-between">
          <Group gap="xs" align="center">
            <ThemeIcon bg="none" size="xs" opacity={0.75}>
              <IconCalendar />
            </ThemeIcon>
            <Text type="caption" c="white">
              {datetime}
            </Text>
          </Group>
          <Group gap="xs" align="center">
            <ThemeIcon bg="none" size="xs" opacity={0.75}>
              <IconTicket />
            </ThemeIcon>
            <Text type="caption" c="white">
              {ticketCount}
            </Text>
          </Group>
        </Group>
      </Stack>
    </Card>
  );
};

export { EventWalletCard };
